/**
 * De corporaties van de ingelogde tenant.
 *
 * De schil toont hiermee wát de schermen lezen. Dat is geen detail: de
 * leeslaag lost een ontbrekende `corporation_id` op door te eisen dat de tenant
 * er precies één heeft, dus de naam in de header is de corporatie waar élk
 * cijfer op de pagina vandaan komt.
 */
import { api } from "./client";

export type Corporation = {
  id: string;
  name: string;
  code: string | null;
  /** Huisstijllogo van de klant; `null` zolang er geen is gezet. */
  logo_url: string | null;
  /** Twee letters uit de naam, als terugval voor een ontbrekend logo. */
  monogram: string;
  asset_count: number;
  /** Opgemaakt aangeleverd: de frontend maakt geen getallen op. */
  asset_count_display: string;
};

export const fetchCorporations = async (): Promise<Corporation[]> => {
  const { data } = await api.get<{ corporations: Corporation[] }>("/portfolio/corporations");
  return data.corporations;
};
